import type { ReactNode } from "react";

export interface EmptyStateProps {
  action?: ReactNode;
  description: string;
  icon?: ReactNode;
  title: string;
}

export function EmptyState({ action, description, icon, title }: EmptyStateProps) {
  return (
    <section className="relative overflow-hidden rounded-card border border-dashed border-accent/35 bg-gradient-to-br from-surface via-surface to-accent/[0.08] px-6 py-12 text-center shadow-card ring-1 ring-line/20">
      <span
        aria-hidden="true"
        className="absolute -right-12 -top-16 h-40 w-40 rounded-full bg-highlight/[0.07] blur-3xl"
      />
      {icon && (
        <div
          aria-hidden="true"
          className="relative mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-accent/15 bg-accent/10 text-accent shadow-sm"
        >
          {icon}
        </div>
      )}
      <h2 className="relative font-display text-2xl font-normal">{title}</h2>
      <p className="relative mx-auto mt-2 max-w-md text-sm leading-relaxed text-muted">
        {description}
      </p>
      {action && <div className="relative mt-6">{action}</div>}
    </section>
  );
}
